import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import {
  DeleteCandidateInterviews,
  GetAllUsers,
  GetCandidate,
  GetVacanciesList,
  ScheduleCandidateInterviews,
} from '../services/httpServices';

import styled from '@emotion/styled';

import Label from '../label/Label';
import { sentenceCase } from 'change-case';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const ScheduleInterviews = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { id, vacancyId } = useParams();
  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState({});
  const [selectedInterviewType, setSelectedInterviewType] = useState(null);
  const [selectedVacancy, setSelectedVacancy] = useState(null);
  const [vacancies, setVacancies] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedPanelists, setSelectedPanelists] = useState([]);

  const interviewDateRef = useRef('');
  const startDateRef = useRef('');
  const endDateRef = useRef('');

  const fetchCandidate = async (event) => {
    const candidate = await GetCandidate(id);
    const savedUsers = await GetAllUsers();
    if (!vacancyId) {
      const vacanciesList = await GetVacanciesList();
      setVacancies(vacanciesList);
    }
    console.log('savedUsers', savedUsers);
    setUsers(savedUsers.filter((e) => e.deptId == 6 || e.userRoleId == 1));
    setCandidate(candidate);
    setLoading(false);
  };
  useEffect(() => {
    fetchCandidate();
  }, [location]);

  const ScheduleCandidateInterview = async (event) => {
    event.preventDefault();
    if (selectedPanelists.length <= 0) {
      alert('Please Select Panelists');
    } else {
      setLoading(true);

      const candidateInterview = {
        interviewType: selectedInterviewType?.value,
        interviewDate: interviewDateRef.current.value,
        interviewStart: startDateRef?.current?.value,
        interviewEnd: endDateRef?.current?.value,
        mstCandidateId: id,
        mstVacancyId: vacancyId ? vacancyId : selectedVacancy?.id,
      };
      const payload = {
        candidateInterview: candidateInterview,
        users: selectedPanelists,
      };

      console.log(payload);
      let response = await ScheduleCandidateInterviews(payload);
      console.log('PostResponse:', response);

      if (response.status == 200) {
        props.setMessage('Interview Scheduled Successfully.');
        props.setSaved(true);
        props.setOpen(true);
        let clientSaved = candidate;
        clientSaved.mstCandidateInterviews = response.data;
        setCandidate(clientSaved);
        setLoading(false);
      } else {
        props.setMessage(response.data);
        props.setSaved(false);
        props.setOpen(true);
        setLoading(false);
      }
    }
  };

  const deleteCandidateInterviews = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteCandidateInterviews(rowId);

    if (response.status == 200) {
      props.setMessage('Candidate Interview deleted successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let candidateSaved = candidate;
      candidateSaved.mstCandidateInterviews = response.data;
      setCandidate(candidateSaved);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const ChangePanelistHandle = (panelist) => {
    console.log('Event:', panelist);
    setSelectedPanelists(panelist);
  };
  const handleClickInterview = (row) => {
    console.log('row', row);
    navigate(`/app/InterviewDetail/${row.id}/${row.mstCandidateId}`);
  };
  const interviewTypes = [
    { value: 'Initial Interview' },
    { value: 'Employer Interview' },
    { value: 'Final Interview' },
  ];
  return (
    <>
      <form onSubmit={ScheduleCandidateInterview}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  {vacancyId ? null : (
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="vacancyId"
                        size="small"
                        options={vacancies}
                        // defaultValue={userList.find((e) => e.key == user.deptId)}
                        getOptionLabel={(source) => source?.vacancyName}
                        renderInput={(params) => <TextField required {...params} label="Vacancy" variant="outlined" />}
                        onChange={(event, vacancy) => setSelectedVacancy(vacancy)}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="interviews"
                      size="small"
                      options={interviewTypes}
                      // defaultValue={userList.find((e) => e.key == user.deptId)}
                      getOptionLabel={(source) => source.value}
                      renderInput={(params) => <TextField {...params} label="Interview Type" variant="outlined" />}
                      onChange={(event, interviewType) => setSelectedInterviewType(interviewType)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Interview Date"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={interviewDateRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Start Time"
                      type="time"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={startDateRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="End Time"
                      type="time"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={endDateRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={6}>
                    {' '}
                    <Autocomplete
                      multiple
                      size="small"
                      options={users}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Panelists" />}
                      onChange={(event, panelist) => ChangePanelistHandle(panelist)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={12}></Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <br></br>
              <br></br>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                  Scheduled Interviews
                </Typography>
              </Stack>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Type of Interview</TableCell>
                      <TableCell>Interview Date</TableCell>
                      <TableCell>Start Time</TableCell>
                      <TableCell>End Time</TableCell>
                      <TableCell>Vacancy</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {candidate?.mstCandidateInterviews?.map((row, index) => (
                      <TableRow key={index + 1} onClick={() => handleClickInterview(row)}>
                        <TableCell>{row.interviewType}</TableCell>
                        <TableCell>{row.interviewDate?.split('T')[0]}</TableCell>
                        <TableCell>{`${row.interviewStart?.split(':')[0]}:${
                          row.interviewStart?.split(':')[1]
                        }`}</TableCell>
                        <TableCell>{`${row.interviewEnd?.split(':')[0]}:${row.interviewEnd?.split(':')[1]}`}</TableCell>
                        <TableCell>{row.mstVacancy.vacancyName}</TableCell>
                        <TableCell>
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Label
                              color={
                                row.status == 'Pending' ? 'warning' : row.status == 'Rejected' ? 'error' : 'success'
                              }
                            >
                              {row.status == 'Pending'
                                ? sentenceCase('Pending')
                                : row.status == 'Rejected'
                                ? sentenceCase('Rejected')
                                : sentenceCase('Done')}
                            </Label>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default ScheduleInterviews;
